import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    var isDark = useTheme().isDark;
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 32 28"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    x: "-42.9%",
                    y: "-42.9%",
                    width: "185.7%",
                    height: "185.7%",
                    filterUnits: "objectBoundingBox",
                    id: "filter-1",
                    children: [
                        /*#__PURE__*/ _jsx("feOffset", {
                            dx: "0",
                            dy: "2",
                            in: "SourceAlpha",
                            result: "shadowOffsetOuter1"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "2",
                            in: "shadowOffsetOuter1",
                            result: "shadowBlurOuter1"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
                            type: "matrix",
                            in: "shadowBlurOuter1",
                            result: "shadowMatrixOuter1"
                        }),
                        /*#__PURE__*/ _jsxs("feMerge", {
                            children: [
                                /*#__PURE__*/ _jsx("feMergeNode", {
                                    in: "shadowMatrixOuter1"
                                }),
                                /*#__PURE__*/ _jsx("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "兑换首页",
                    transform: "translate(-1860.000000, -598.000000)",
                    fill: isDark ? "#C3C9D0" : "#002236",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "telegram",
                        transform: "translate(1851.000000, 584.000000)",
                        children: /*#__PURE__*/ _jsxs("g", {
                            id: "bxl-telegram",
                            filter: "url(#filter-1)",
                            transform: "translate(11.000000, 12.000000)",
                            children: [
                                /*#__PURE__*/ _jsx("rect", {
                                    id: "矩形",
                                    opacity: "0",
                                    x: "0",
                                    y: "0",
                                    width: "28",
                                    height: "28"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M24.1091758,4.3365 L3.42417578,12.313 C2.0125,12.88 2.02067578,13.6675 3.16517578,14.0186758 L8.47582422,15.6753242 L20.7632031,7.92285156 C21.3442031,7.56935156 21.8750273,7.75952734 21.4387031,8.14685156 L11.4835,17.1313242 L11.4811758,17.1313242 L11.4835,17.1325 L11.1171758,22.6065 C11.6538242,22.6065 11.8906758,22.3603242 12.1916758,22.0698242 L14.7711758,19.5615 L20.1366758,23.5246758 C21.126,24.0695 21.8365,23.7895 22.0826758,22.6088242 L25.6048242,6.0095 C25.9653242,4.564 25.053,3.9095 24.1091758,4.3365 Z",
                                    id: "路径"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
